(function () {
  if (window.NXReviewLive) return;
  var pages = {}, summaries = {}, queue = [], active = 0;
  function drain() {
    while (active < 4 && queue.length) { active++; queue.shift()(); }
  }
  function page(id, number) {
    var key = id + ':' + number;
    if (!pages[key]) pages[key] = new Promise(function (resolve, reject) {
      queue.push(function () {
        var shop = window.Shopify && window.Shopify.shop || 'nexrafit.com';
        var url = 'https://api.judge.me/reviews/reviews_for_widget?legacy_widget=true&platform=shopify&per_page=30&shop_domain=' + encodeURIComponent(shop) + '&url=nexrafit.com&product_id=' + encodeURIComponent(id) + '&page=' + number;
        fetch(url).then(function (r) {
          if (!r.ok) throw new Error('Review request failed');
          return r.json();
        }).then(resolve, reject).finally(function () { active--; drain(); });
      });
      drain();
    });
    return pages[key];
  }
  function load(id) {
    if (!summaries[id]) summaries[id] = (async function () {
      var seen = new Set(), scores = [], count = null, number = 1;
      while (count === null || scores.length < count) {
        var response = await page(id, number++);
        if (response.total_count === null || response.total_count === undefined || response.total_count === '') throw new Error('Missing review total');
        var total = Number(response.total_count);
        if (!Number.isInteger(total) || total < 0 || (count !== null && total !== count)) throw new Error('Review total changed');
        count = total;
        var doc = new DOMParser().parseFromString(response.html || '', 'text/html');
        var reviews = Array.from(doc.querySelectorAll('.jdgm-rev'));
        if (!reviews.length && scores.length < count) throw new Error('Incomplete reviews');
        reviews.forEach(function (review) {
          var key = review.getAttribute('data-review-id'), rating = review.querySelector('.jdgm-rev__rating');
          var score = rating && Number(rating.getAttribute('data-score'));
          if (!key || seen.has(key) || !Number.isInteger(score) || score < 1 || score > 5) throw new Error('Invalid review data');
          seen.add(key); scores.push(score);
        });
        if (scores.length > count) throw new Error('Review total mismatch');
      }
      var histogram = [0, 0, 0, 0, 0], sum = 0;
      scores.forEach(function (score) { histogram[score - 1]++; sum += score; });
      return { count: count, average: count ? sum / count : null, histogram: histogram };
    })();
    return summaries[id];
  }
  window.NXReviewLive = { load: load, firstPage: function (id) { return page(id, 1); } };
  function stars(average) {
    var result = '', halves = Math.round(average * 2);
    for (var i = 0; i < 5; i++) result += '<span class="jdgm-star jdgm--' + (halves >= (i + 1) * 2 ? 'on' : halves === i * 2 + 1 ? 'half' : 'off') + '"></span>';
    return result;
  }
  function visible(node, show) {
    if (!node) return;
    node.hidden = !show; node.style.display = show ? '' : 'none';
  }
  function apply(node, data) {
    var kind = node.getAttribute('data-nx-live-review'), count = data.count;
    var average = data.average === null ? '' : String(Math.round(data.average * 100) / 100);
    if (kind === 'pdp') {
      var text = node.querySelector('.nx-pdp-rating__n'), fill = node.querySelector('.nx-pdp-rating__on'), link = node.querySelector('.nx-pdp-rating');
      var score = node.querySelector('.nx-pdp-rating__v'); if (score && data.average !== null) score.textContent = (Math.round(data.average * 10) / 10).toFixed(1);
      if (text) { text.textContent = '(' + count + (count === 1 ? ' review)' : ' reviews)'); text.style.visibility = ''; }
      if (fill) fill.style.width = count ? data.average / 5 * 100 + '%' : '0%';
      if (link) link.setAttribute('aria-label', 'Rated ' + average + ' out of 5, ' + count + ' reviews. Go to reviews');
      visible(node, count > 0); node.style.visibility = '';
    } else if (kind === 'rating') {
      var star = node.querySelector('.rating-star'), text = node.querySelector('.rating-text span'), number = node.querySelector('.rating-count [aria-hidden]'), label = node.querySelector('.rating');
      if (star) { star.style.setProperty('--rating', Math.floor(data.average || 0)); star.style.setProperty('--rating-max', 5); star.style.setProperty('--rating-decimal', Math.round((data.average % 1 || 0) * 2) / 2); }
      if (text) text.textContent = average + ' / 5'; if (number) number.textContent = '(' + count + ')';
      var hidden = node.querySelector('.rating-count .visually-hidden'); if (hidden) hidden.textContent = count + ' reviews';
      if (label) label.setAttribute('aria-label', average + ' out of 5');
      visible(node, count > 0); if (count) node.style.display = 'contents';
    } else if (kind === 'badge') {
      node.innerHTML = count ? '<div class="jdgm-prev-badge" data-average-rating="' + average + '" data-number-of-reviews="' + count + '"><span class="jdgm-prev-badge__stars" aria-label="' + average + ' stars">' + stars(data.average) + '</span> <span class="jdgm-prev-badge__text">' + count + (count === 1 ? ' review' : ' reviews') + '</span></div>' : '';
      visible(node, count > 0);
    } else if (kind === 'widget') {
      var widget = node.querySelector('.jdgm-rev-widg'), header = node.querySelector('.jdgm-rev-widg__header'), status = node.querySelector('.nx-review-status');
      if (widget) { widget.setAttribute('data-average-rating', average); widget.setAttribute('data-number-of-reviews', count); }
      var summary = node.querySelector('.jdgm-rev-widg__summary-text'), summaryStars = node.querySelector('.jdgm-rev-widg__summary-stars');
      if (summary) summary.textContent = 'Based on ' + count + (count === 1 ? ' review' : ' reviews');
      if (summaryStars) { summaryStars.innerHTML = stars(data.average || 0); summaryStars.setAttribute('aria-label', 'Average rating is ' + average + ' stars'); }
      node.querySelectorAll('.jdgm-histogram__row[data-rating]').forEach(function (row) {
        var rating = Number(row.getAttribute('data-rating'));
        if (!(rating >= 1 && rating <= 5)) return;
        var frequency = data.histogram[rating - 1], percentage = count ? Math.round(frequency / count * 100) : 0;
        row.setAttribute('data-frequency', frequency); row.setAttribute('data-percentage', percentage);
        var bar = row.querySelector('.jdgm-histogram__bar-content'), pct = row.querySelector('.jdgm-histogram__percentage'), number = row.querySelector('.jdgm-histogram__frequency');
        if (bar) bar.style.width = percentage + '%'; if (pct) pct.textContent = percentage + '%'; if (number) number.textContent = '(' + frequency + ')';
        var star = row.querySelector('.jdgm-histogram__star'); if (star) star.setAttribute('aria-label', percentage + '% (' + frequency + ') reviews with ' + rating + ' star rating');
      });
      visible(header, count > 0);
      if (status) { status.textContent = count ? '' : 'No reviews yet.'; visible(status, !count); }
      if (!count) { var list = node.querySelector('.jdgm-rev-widg__reviews'); if (list) list.innerHTML = ''; visible(node.querySelector('.jdgm-paginate'), false); }
    }
    node.setAttribute('data-nx-live-state', 'ready');
  }
  function scan() {
    document.querySelectorAll('[data-nx-live-review]:not([data-nx-live-started])').forEach(function (node) {
      node.setAttribute('data-nx-live-started', 'true');
      var id = node.getAttribute('data-nx-review-product-id');
      if (!id) return;
      load(id).then(function (data) { if (node.isConnected) apply(node, data); }).catch(function () {
        node.setAttribute('data-nx-live-state', 'unavailable');
        if (node.getAttribute('data-nx-live-review') !== 'widget') visible(node, false);
        else { var status = node.querySelector('.nx-review-status'); if (status) status.textContent = 'Reviews are temporarily unavailable.'; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  var pending = false;
  if (window.MutationObserver && document.body) new window.MutationObserver(function () {
    if (!pending) { pending = true; Promise.resolve().then(function () { pending = false; scan(); }); }
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', scan);
})();
